import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import API from '../utils/api';

const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || '';

export default function Management() {
  const { t } = useTranslation();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/management').then(r => { setMembers(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="page-header">
        <h1>{t('management.pageTitle')}</h1>
        <p>{t('management.pageSubtitle')}</p>
      </div>

      <section className="section">
        <div className="container">
          {loading ? (
            <div className="loader"><div className="spinner" /></div>
          ) : members.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 0', color: '#888' }}>
              <div style={{ fontSize: '4rem', marginBottom: 12 }}>🙏</div>
              <p>{t('management.noMembers')}</p>
            </div>
          ) : (
            <div className="management-grid">
              {members.map(m => (
                <div key={m._id} className="management-card">
                  <div className="management-photo-wrap">
                    {m.image
                      ? <img src={`${API_BASE}${m.image}`} alt={m.name} className="management-photo" />
                      : <div className="management-photo management-photo-placeholder">👤</div>
                    }
                  </div>
                  <div className="management-info">
                    <div className="management-name">{m.name}</div>
                    <div className="management-designation">{m.designation}</div>
                    {m.bio && <p className="management-bio">{m.bio}</p>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
